/**
 * Value object to represent the result of a privilege check.
 *
 * @param {string} privilegeName
 */
class PrivilegeCheckResult {
    constructor(privilegeName) {
        /**
         * The userID that granted this permission.
         * This might be the same userID as the current user, if the logged in user already has the permission.
         * If the current user did not have permission and a manager approved the action this will be the manager's ID.
         * This will be null if the privilege was not granted.
         *
         * @type {number|null}
         */
        this.grantedBy = null;

        /**
         * Indicates if the privilege was granted or not.
         *
         * @type {boolean}
         */
        this.granted = false;

        /**
         * Plaintext name of the requested privilege.
         *
         * @type {string}
         */
        this.privilegeName = privilegeName;
    }
}

module.exports = PrivilegeCheckResult;
